import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/megaport': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M214.5 209.6l33.4-33.4 33.4 33.4v66.4l-33.3 33.3-33.5-33.5v-66.2zM248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM393.1 422.4h0.1v-87.1l-59.7-59.7v-87.6l-59.5-59.5v-75.6l-26.1-19.2-26.1 19.2v75.6l-59.5 59.5v87.9l-59.5 59.5v87l26.1 19.2 26.1-19.2v-65.5l33.5-33.4 33.4 33.4v65.5l26.1 19.2 26.2-19.2v-65.5l33.4-33.4 33.4 33.4v65.5l26 19.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/megaport.js
// module id = null
// module chunks = 